/**
 * TanStack Query hooks for `cap-limits-campaign-publisher-geo-landing-page-levels`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	capLimitsCampaignPublisherGeoLandingPageLevelsQueryKeys,
	type CreateCapLimitsCampaignPublisherGeoLandingPageLevelsBody,
	type ListCapLimitsCampaignPublisherGeoLandingPageLevelsResponse,
	type CapLimitsCampaignPublisherGeoLandingPageLevelsRow,
} from "./api";

export function useCapLimitsCampaignPublisherGeoLandingPageLevelsList(): UseQueryResult<ListCapLimitsCampaignPublisherGeoLandingPageLevelsResponse, Error> {
	return useQuery({
		queryKey: capLimitsCampaignPublisherGeoLandingPageLevelsQueryKeys.list(),
		queryFn: list,
	});
}

export function useCapLimitsCampaignPublisherGeoLandingPageLevelsCreate(): UseMutationResult<CapLimitsCampaignPublisherGeoLandingPageLevelsRow, Error, CreateCapLimitsCampaignPublisherGeoLandingPageLevelsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capLimitsCampaignPublisherGeoLandingPageLevelsQueryKeys.all });
		},
	});
}

export function useCapLimitsCampaignPublisherGeoLandingPageLevelsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capLimitsCampaignPublisherGeoLandingPageLevelsQueryKeys.all });
		},
	});
}
